import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  shared: {
    NODE_ENV: z.enum(["development", "production", "staging"]),
  },
  server: {
    AWS_REGION: z.string(),

    PDFPARSE_ENVIRONMENT: z.enum(['development', 'production', 'staging']).default('development'),
    AWS_SECRET_KEY: z.string(),
    BUCKET_NAME: z.string(),
    AWS_ACCESS_ID: z.string(),
    PADDLE_PRODUCT_ID: z.string(),
    PADDLE_PRICE_ID_FREE: z.string(),
    PADDLE_PRICE_ID_BASIC: z.string(),
    PADDLE_PRICE_ID_PRO: z.string(),
    PADDLE_PRICE_ID_PREMIUM: z.string(),
    PADDLE_PRICE_ID_ENTERPRISE: z.string(),
    CF_API_TOKEN: z.string(),
    WORKFLOW_INSTANCE_ID: z.string(),
    MISTRAL_API_KEY: z.string(),
    CF_ACCESS_KEY_ID: z.string(),
    CF_SECRET_KEY: z.string(),
    CF_ACCOUNT_ID: z.string(),
    CF_S3_URL: z.string().url(),
    WEBHOOK_SECRET: z.string(),
    PADDLE_API_KEY: z.string(),
    PADDLE_WEBHOOK_SECRET: z.string().optional(),
    PADDLE_ENVIRONMENT: z.enum(["sandbox", "production"]).default("sandbox"),
    AWS_SES_FROM_EMAIL: z.string().email(),
    AWS_SES_FROM_NAME: z.string().default("PDFParse"),
    TURNSTILE_SECRET_KEY: z.string(),
  },
  client: {
    // NEXT_PUBLIC_CLIENTVAR: z.string(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_POSTHOG_HOST: z.string().url(),
    NEXT_PUBLIC_BASE_URL: z.string().url(),
    NEXT_PUBLIC_PADDLE_CLIENT_TOKEN: z.string(),
    NEXT_PUBLIC_PADDLE_ENVIRONMENT: z.enum(["sandbox", "production"]).default("sandbox"),
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: z.string(),
  },
  runtimeEnv: {
    PADDLE_PRODUCT_ID: process.env.PADDLE_PRODUCT_ID,
    PADDLE_PRICE_ID_FREE: process.env.PADDLE_PRICE_ID_FREE,
    PADDLE_PRICE_ID_PREMIUM: process.env.PADDLE_PRICE_ID_PREMIUM,
    PADDLE_PRICE_ID_BASIC: process.env.PADDLE_PRICE_ID_BASIC,
    PADDLE_PRICE_ID_PRO: process.env.PADDLE_PRICE_ID_PRO,
    PADDLE_PRICE_ID_ENTERPRISE: process.env.PADDLE_PRICE_ID_ENTERPRISE,
    AWS_REGION: process.env.AWS_REGION,
    AWS_ACCESS_ID: process.env.AWS_ACCESS_ID,
    AWS_SECRET_KEY: process.env.AWS_SECRET_KEY,
    BUCKET_NAME: process.env.BUCKET_NAME,
    PDFPARSE_ENVIRONMENT: process.env.PDFPARSE_ENVIRONMENT,
    CF_ACCESS_KEY_ID: process.env.CF_ACCESS_KEY_ID,
    WORKFLOW_INSTANCE_ID: process.env.WORKFLOW_INSTANCE_ID,
    CF_SECRET_KEY: process.env.CF_SECRET_KEY,
    CF_API_TOKEN: process.env.ORANGE_API_TOKEN,
    CF_S3_URL: process.env.CF_S3_URL,
    WEBHOOK_SECRET: process.env.WEBHOOK_SECRET,
    CF_ACCOUNT_ID: process.env.CLOUDFLARE_ACCOUNT_ID,
    NODE_ENV: process.env.NODE_ENV,
    MISTRAL_API_KEY: process.env.MISTRAL_API_KEY,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_PADDLE_CLIENT_TOKEN: process.env.NEXT_PUBLIC_PADDLE_CLIENT_TOKEN,
    NEXT_PUBLIC_PADDLE_ENVIRONMENT: process.env.NEXT_PUBLIC_PADDLE_ENVIRONMENT,
    PADDLE_API_KEY: process.env.PADDLE_API_KEY,
    PADDLE_WEBHOOK_SECRET: process.env.PADDLE_WEBHOOK_SECRET,
    PADDLE_ENVIRONMENT: process.env.PADDLE_ENVIRONMENT,
    AWS_SES_FROM_EMAIL: process.env.AWS_SES_FROM_EMAIL,
    AWS_SES_FROM_NAME: process.env.AWS_SES_FROM_NAME,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    TURNSTILE_SECRET_KEY: process.env.TURNSTILE_SECRET_KEY,
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
  },
});
